/*
 * Ryan O'Dowd
 * 2020-11-29
 * © Copyright 2020 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  ScrollView,
  View,
} from 'react-native';
import Footer from '@website/components/Footer';
import NavigationTabs from './NavigationTabs';
import React from 'react';
import ScreenWrapper from '@containers/ScreenWrapper';
import WebHeader from '@website/components/WebHeader';
import getStyles from './styles';
import hooks from '@hooks';

const WebPageStub = (props: WebPageStubProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.outerContainer(props.isWebApp)}>
      <WebHeader
        navigationTabs={!props.hideTabs ? <NavigationTabs /> : null}
        isWebApp={props.isWebApp}
      />
      <ScreenWrapper fullWidth={props.fullWidth || !props.isWebApp} isLandingPage={!props.isWebApp}>
        <ScrollView style={styles.scrollWrapper} contentContainerStyle={styles.scrollWrapper}>
          {props.children}
          {!props.isWebApp &&
            <React.Fragment>
              <View style={styles.spacerBeforeFooter} />
              <Footer />
            </React.Fragment>
          }
        </ScrollView>
      </ScreenWrapper>
    </View>
  );
};

class WebPageStubProps {
  children: React.ReactNode;

  hideTabs?: boolean;
  isWebApp?: boolean;
  fullWidth?: boolean;
};

export default WebPageStub;
